import { LegalDocumentPage } from "./LegalDocumentPage";
import termsOfUseSource from "./terms-of-use.txt?raw";

export function TermsOfUsePage() {
  return <LegalDocumentPage source={termsOfUseSource} />;
}
